export default __webpack_public_path__ + "static/media/sales-process.f9e31c3d.png";